import { createFileRoute, Outlet } from "@tanstack/react-router";
import { DashboardShell } from "@/components/dashboard-shell";

// Was the (crm-demos) route group's layout.tsx. `_crm-demos` is a pathless
// layout: it wraps /crm-1 … /crm-9 and /account-details without adding a
// segment, the same way the parenthesised Next group did.
//
// Demo pages keep the app sidebar (with the ReUI demos group) and render each
// block in the content area, in the preview's Inter typeface. The font used to
// come from a next/font class; `--font-crm-inter` is declared in globals.css.
export const Route = createFileRoute("/_crm-demos")({
  component: CrmDemosLayout,
});

function CrmDemosLayout() {
  return (
    <div className="min-h-svh bg-background font-[family-name:var(--font-crm-inter)] antialiased">
      <DashboardShell>
        <Outlet />
      </DashboardShell>
    </div>
  );
}
